// Detalhes do que está num espaço da barra de ações: mouse em cima (computador) ou toque longo (celular).
import type { HotbarSlot } from '../../../../shared/src/game/helper';
import { potionOf } from '../../../../shared/src/game/combat';
import { GROUP_NAMES } from '../../../../shared/src/game/spells';
import { runeByItem, spellByWords } from '../spells';
import { catalogNow } from '../items';
import { itemCost, shortGp } from '../potionPrice';
import { spellInfo, whatSpell } from './AutoHelper';

const n = (v: number) => v.toLocaleString('pt-BR');

/** quando a caça automática usa o espaço */
function autoLine(sl: HotbarSlot, heal: boolean, attack: boolean): string {
  if (!sl.auto) return 'Só manual: a caça automática não usa este espaço.';
  if (heal) return `Caça automática: usa quando ${sl.stat === 'mana' ? 'a mana' : 'a vida'} estiver abaixo de ${sl.below}%${sl.who ? ` (cura ${sl.who})` : ''}.`;
  if (attack) return `Caça automática: usa com ${sl.minMonsters > 1 ? `${sl.minMonsters} ou mais monstros por perto` : 'qualquer monstro'}${sl.minMana ? ` e mana acima de ${sl.minMana}%` : ''}.`;
  return 'Caça automática: usa sempre que puder.';
}

export function SlotDetails(props: { slot: HotbarSlot; keyHint?: string; count?: number }) {
  const sl = props.slot;
  if ('spell' in sl.use) {
    const s = spellByWords(sl.use.spell);
    if (!s) return <div class="st-box"><b>{sl.use.spell}</b></div>;
    return (
      <div class="st-box">
        <b>{s.name}</b> <em class="st-words">"{s.words}"</em>
        <span class="st-tag">{GROUP_NAMES[s.group] ?? s.group} · level {s.level}{s.ml ? ` · ML ${s.ml}` : ''}</span>
        <span class="st-info">{spellInfo(s)}</span>
        <p>{whatSpell(s)}</p>
        <span class="st-auto">{autoLine(sl, s.group === 'healing', s.group === 'attack')}</span>
        {props.keyHint && <span class="st-key">{props.keyHint}</span>}
      </div>
    );
  }
  const id = sl.use.item, name = catalogNow()?.get(id)?.name ?? 'Item', r = runeByItem(id), pot = potionOf(name), cost = itemCost(id);
  return (
    <div class="st-box">
      <b>{r ? r.name : name.replace(/\b\w/g, (c) => c.toUpperCase())}</b>{r && <em class="st-words"> runa</em>}
      {r && <><span class="st-tag">{GROUP_NAMES[r.group] ?? r.group} · ML {r.ml}</span><span class="st-info">{spellInfo(r)}</span><p>{whatSpell(r)}</p></>}
      {pot && <p>{pot.kind === 'health' ? `Cura de ${n(pot.min)} a ${n(pot.max)} de vida.` : pot.kind === 'mana' ? `Recupera de ${n(pot.min)} a ${n(pot.max)} de mana.` : `Cura de ${n(pot.min)} a ${n(pot.max)} de vida e ${n(pot.mmin ?? 0)} a ${n(pot.mmax ?? 0)} de mana.`}{pot.level ? ` Level ${pot.level}+.` : ''} Espera 1 s entre poções.</p>}
      <span class="st-info">{cost !== undefined ? `Custo por uso: ${shortGp(cost)} do banco` : props.count !== undefined ? `Você tem ${n(props.count)}` : ''}</span>
      <span class="st-auto">{autoLine(sl, !!pot || r?.group === 'healing', r?.group === 'attack')}</span>
      {props.keyHint && <span class="st-key">{props.keyHint}</span>}
    </div>
  );
}
